(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chrissie-campaign-clock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-campaign-clock')) {
    class ChrissieCampaignClock extends HTMLElement {
      connectedCallback() {
        this.boundary = Date.parse(this.dataset.nextBoundary);
        this.done = false;
        this.checkBoundary = this.checkBoundary.bind(this);
        document.addEventListener('visibilitychange', this.checkBoundary);
        this.checkBoundary();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.checkBoundary);
      }
      checkBoundary() {
        clearTimeout(this.timer);
        if (this.done || !Number.isFinite(this.boundary)) return;
        const remaining = this.boundary - Date.now();
        if (remaining > 0) {
          this.timer = setTimeout(this.checkBoundary, Math.min(remaining, 3600000));
          return;
        }
        if (document.visibilityState === 'hidden') return;
        this.done = true;
        document.querySelectorAll('[data-cc-expiring-promotion], .cc-campaigns, .cc-campaign-announcement, .cc-bundle, .cc-routine-promo, .announcement-bar__slider').forEach((element) => {
          element.hidden = true;
          element.style.setProperty('display', 'none', 'important');
        });
        try {
          const key = 'cc-campaign-refreshed-' + this.dataset.nextBoundary;
          if (sessionStorage.getItem(key)) return;
          sessionStorage.setItem(key, '1');
        } catch (_) {
          return;
        }
        window.location.reload();
      }
    }
    customElements.define('cc-campaign-clock', ChrissieCampaignClock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chrissie-mobile-ux"] && !Shopify.designMode) return;
  try {
    (() => {
    let frame = 0;
    let observedChatRoot = null;
    let chatObserver = null;

    function chatActivator() {
      return document.querySelector('shopify-chat')?.shadowRoot?.querySelector('button.activator');
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(refreshControls);
    }

    function refreshControls() {
      frame = 0;
      const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
      if (chatRoot && chatRoot !== observedChatRoot) {
        if (chatObserver) chatObserver.disconnect();
        observedChatRoot = chatRoot;
        chatObserver = new MutationObserver(schedule);
        chatObserver.observe(chatRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      }
      const activator = chatActivator();
      const ready = Boolean(activator && !activator.disabled);
      document.querySelectorAll('[data-chrissie-chat-control]').forEach(control => {
        control.hidden = !ready;
        const button = control.matches('button') ? control : control.querySelector('button');
        if (button) button.disabled = !ready;
      });
    }

    function closeNavigation(trigger) {
      const drawer = trigger.closest('header-drawer');
      const details = drawer?.querySelector('details');
      if (!details?.open || typeof drawer.toggleDrawer !== 'function') return Promise.resolve();
      return new Promise(resolve => {
        let timeout;
        const observer = new MutationObserver(() => {
          if (!details.open) finish();
        });
        function finish() {
          observer.disconnect();
          window.clearTimeout(timeout);
          window.requestAnimationFrame(resolve);
        }
        observer.observe(details, { attributes: true, attributeFilter: ['open'] });
        timeout = window.setTimeout(finish, 650);
        drawer.toggleDrawer();
      });
    }

    document.addEventListener('click', async event => {
      const trigger = event.target.closest('[data-chrissie-open-chat]');
      if (!trigger || trigger.disabled) return;
      event.preventDefault();
      trigger.disabled = true;
      await closeNavigation(trigger);
      const activator = chatActivator();
      if (activator && !activator.disabled) {
        activator.click();
      } else if (trigger.dataset.contactUrl) {
        window.location.assign(trigger.dataset.contactUrl);
      }
      refreshControls();
    });

    window.addEventListener('load', schedule);
    customElements.whenDefined('shopify-chat').then(schedule);
    const contentObserver = new MutationObserver(schedule);
    contentObserver.observe(document.body, { childList: true, subtree: true });
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

})();
